import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { faqs } from "./data";

export const FAQ = () => (
    <section id="faq" className="bg-slate-50 py-20 sm:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
                <p className="text-xs font-bold uppercase tracking-[0.22em] text-teal-600 mb-4">FAQ</p>
                <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
                    Common Questions
                </h2>
            </div>

            <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
                {faqs.map((f, i) => (
                    <AccordionItem
                        key={i}
                        value={`faq-${i}`}
                        data-testid={`faq-item-${i + 1}`}
                        className="bg-white rounded-2xl border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] px-6 overflow-hidden"
                    >
                        <AccordionTrigger
                            data-testid={`faq-trigger-${i + 1}`}
                            className="text-left text-[15px] font-semibold text-slate-800 py-5 hover:no-underline hover:text-teal-700 transition-colors duration-200"
                        >
                            {f.q}
                        </AccordionTrigger>
                        <AccordionContent data-testid={`faq-content-${i + 1}`} className="text-sm leading-relaxed text-slate-500 pb-5">
                            {f.a}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    </section>
);
